"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Pill = require("./Pill");

var _Pill2 = _interopRequireDefault(_Pill);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledWrapper = _styledComponents2.default.div.withConfig({
  displayName: "Pills__StyledWrapper",
  componentId: "ja4vzy-0"
})([""]);

const StyledDiv = _styledComponents2.default.div.withConfig({
  displayName: "Pills__StyledDiv",
  componentId: "ja4vzy-1"
})(["display:flex;"]);

const StyledLabel = _styledComponents2.default.label.withConfig({
  displayName: "Pills__StyledLabel",
  componentId: "ja4vzy-2"
})(["", " display:block;margin-bottom:8px;font-size:12px;font-weight:500;line-height:15px;"], _styles.defaultBody);

const Pills = (_ref) => {
  let {
    children,
    onSelect = Function.prototype,
    label
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "onSelect", "label"]);

  return _react2.default.createElement(
    StyledWrapper,
    null,
    label && _react2.default.createElement(
      StyledLabel,
      null,
      label
    ),
    _react2.default.createElement(
      StyledDiv,
      props,
      // TODO: Check if a child is not a Pill. Throw error if it is not
      _react2.default.Children.map(children, child => _react2.default.cloneElement(child, {
        onClick: e => {
          if (child.props.onClick) {
            child.props.onClick(e);
          }

          onSelect(child.props.value);
        }
      }))
    )
  );
};

Pills.propTypes = {
  /**
   * Pills expects children to be `<Pill />`
   */
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  onSelect: _propTypes2.default.func,
  label: _propTypes2.default.string
};

Pills.Pill = _Pill2.default;

exports.default = Pills;